import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_WEBSITE_RANGE, isWebsiteVisitsRange, WebsitePage, type WebsiteVisitsRange } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

interface WebsiteSearch {
  /** Period; omitted = last 30 days (keeps the default URL clean). */
  range?: WebsiteVisitsRange;
}

/** Every agency member may view it, like Demo requests (the parent layout gates non-agency users). */
export const Route = createFileRoute('/_auth/agency/website')({
  validateSearch: (search: Record<string, unknown>): WebsiteSearch =>
    isWebsiteVisitsRange(search.range) && search.range !== DEFAULT_WEBSITE_RANGE ? { range: search.range } : {},
  component: WebsiteRoute,
});

function WebsiteRoute() {
  const { range = DEFAULT_WEBSITE_RANGE } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Website')}</title>
      </Helmet>
      <WebsitePage
        range={range}
        onRangeChange={(next) =>
          void navigate({ search: next === DEFAULT_WEBSITE_RANGE ? {} : { range: next }, replace: true })
        }
      />
    </>
  );
}
